import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  InputLabel,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Anchor } from '../../Anchor';
import STRING_KEYS from '../../../language/keys';
import { styleTalentDetails } from '../../../pages/TalentsPage/styles';
import TableBasicEditRow from '../../../pages/TalentsPage/TalentsEdit/TalentBasicDetails/TalentBasicRow';
import { TALENTS_BASIC_INPUTS_NAME } from '../../../pages/TalentsPage/Constants';
import { JsonRenderer } from '../../JsonRenderer/json-renderer.component';

type MetadataTabProps = {
  match: MatchFormattedResponse,
}

export const MetadataTab = ({
  match,
}: MetadataTabProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const renderEmptyState = () => {
    return (
      <TableRow>
        <TableCell colSpan={ 3 } color="secondary">
          <Typography variant="overline" sx={ { color: 'text.secondary' } }>
            {translate(STRING_KEYS.NO_RESULTS)}
          </Typography>
        </TableCell>
      </TableRow>
    );
  };

  const renderMetadata = () => {
    if (!match.metadata) {
      return renderEmptyState();
    }

    return Object.keys(match.metadata).map((key: string, index: number, keys: string[]) => {
      if (key === 'matchingMetadata') {
        return (
          <div key={ key }>
            <Grid sx={ styleTalentDetails.cardContent.form.box }
              container
            >
              <Grid item xs={ styleTalentDetails.cardContent.form.boxLabel.xs }>
                <InputLabel
                  htmlFor={ TALENTS_BASIC_INPUTS_NAME.FIRST_NAME }
                  style={ styleTalentDetails.cardContent.form.InputLabel }
                >
                  matchingMetadata
                </InputLabel>
              </Grid>
              <Grid item xs={ styleTalentDetails.cardContent.form.boxInput.xs }>
                <JsonRenderer src={ match.metadata[key] as Record<string, unknown> } collapsed />
              </Grid>
            </Grid>
            <Divider />
          </div>
        );
      }

      return (
        <div key={ key }>
          <TableBasicEditRow
            value={ String(match.metadata[key]) }
            name={ TALENTS_BASIC_INPUTS_NAME.FIRST_NAME }
            label={ key }
          />
          { index < keys.length - 1 && <Divider /> }
        </div>
      );
    });
  };

  return (
    <Box>
      <Card style={ {
        marginTop: '32px',
        position: 'relative',
        backgroundColor: 'white',
      } }
      >
        <Anchor id="basic-details" />
        <CardHeader title={ (
          <Typography variant="h6">
            { translate(STRING_KEYS.MATCH_PAGE_TAB_METADATA) }
          </Typography>
        ) }
        />
        <Divider />
        <CardContent style={ styleTalentDetails.cardContent.form.CardContent.removePB }
          sx={ styleTalentDetails.cardContent.form.CardContent.sx }
        >
          {renderMetadata()}
        </CardContent>
      </Card>
    </Box>
  );
};
